import { useState } from "react";
import { useCreateContactMutation } from "../../../../Redux/Apis/contactApi";
import { useGetSettingQuery } from "../../../../Redux/Apis/siteApi";

function ContactForm() {
    const {data : {contact: {contact_form : {data,name,caption}}}} = useGetSettingQuery()

    const [create,{isLoading : isCreateLoading}] = useCreateContactMutation()
    const [errorMsg, setErrorMsg] = useState(false)
    const [success, setSuccess] = useState(false)
    const [formState, setFormState] = useState({
        name: "",
        email: undefined,
        mobile: undefined,
        subject: "",
        body: ""
    })
    const handleChange = ({ target: { name, value },} ) =>
        setFormState((prev) => ({ ...prev, [name]: value }))

    const onSubmit = async (e) => {
        e.preventDefault()
        const payload = await create(formState)
        if (payload?.error?.data === "sended!"){
            e.target.reset()
            setSuccess(true)
            setErrorMsg(false)
        }else{
            setSuccess(false)   
            const message = !payload?.error?.data ? '' : Array.isArray(payload?.error?.data.message) ? payload?.error?.data.message[0] : payload?.error?.data.message
            setErrorMsg(message)   
        }
    }

    return ( 
        <div className="contact-from-section mt-150 mb-150">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 mb-5 mb-lg-0">
                        <div className="form-title">
                            <h2>{name}</h2>
                            {caption && <p>{caption}</p>}
                        </div>
                        <div id="form_status"></div>
                        {!success ?
                        data.mdl_message && <div className="contact-form">
                            <form type="POST" id="fruitkha-contact" onSubmit={onSubmit}>
                                <p>
                                    <input type="text" placeholder="نام" name="name" onChange={handleChange}  id="name"/>
                                    <input type="email" dir="ltr" placeholder="ایمیل(اختیاری)" name="email" onChange={handleChange}  id="email"/>
                                </p>
                                <p>
                                    <input type="tel" placeholder="تلفن تماس(اختیاری)" name="mobile" onChange={handleChange}  id="phone"/>
                                    <input type="text" placeholder="موضوع" name="subject" onChange={handleChange}  id="subject"/>
                                </p>
                                <p><textarea name="body" id="message" onChange={handleChange}  cols="30" rows="10" placeholder="متن پیام"></textarea></p>
                                <p><input type="submit" disabled={isCreateLoading} value="ارسال"/></p>
                            </form>
                            {errorMsg && <div className="alert alert-danger mt-2" role="alert">
                                {errorMsg}
                            </div>}
                        </div> :
                        <div className="alert alert-success" role="alert">
                            پیام شما با موفقیت ارسال گردید.
                        </div>
                        }
                    </div>

                    <div className="col-lg-4">
                        <div className="contact-form-wrap">
                            <div className="contact-form-box">
                                <h4><i className="fas fa-map"></i> آدرس</h4>
                                <p>{data.txe_time}</p>
                            </div>
                            <div className="contact-form-box">
                                <h4><i className="far fa-clock"></i> ساعات کاری</h4>
                                <p>{data.txe_time}</p>
                            </div>
                            <div className="contact-form-box">
                                <h4><i className="fas fa-address-book"></i> اطلاعات تماس</h4>
                                <p>تلفن: <a href={`tel:${data.txt_phone}`} className="ink-dark" dir="ltr">{data.txt_phone}</a></p>
                                <p>موبایل: <a href={`tel:${data.txt_mobile}`} dir="ltr">{data.txt_mobile}</a></p>
                                <p>ایمیل: <a href={`mailto:${data.txt_email}`} dir="ltr">{data.txt_email}</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ContactForm;